export const StripeNoticeContent = ({ stripeErrorReasons }: { readonly stripeErrorReasons: string[] }) => (
    <>
        {stripeErrorReasons.length > 0 ? (
            <>
                <p>To keep using Vyne Payments, please fix the following issues:</p>
                <ul>
                    {stripeErrorReasons.map((field) => (
                        <li key={field}>{field}</li>
                    ))}
                </ul>
            </>
        ) : (
            <p>Update your Stripe business information to continue using Vyne Payments.</p>
        )}
        <p>Once all fields are updated, refresh the page to continue transacting.</p>
    </>
);
